<template>
  <div class="customer-add-page">
    <el-form
      :model="propsParams"
      ref="ruleForm"
      :rules="rules"
      label-width="130px"
      class="customer-form"
    >
      <!-- 基本信息卡片 -->
      <el-card class="form-card" shadow="hover">
        <div slot="header" class="card-header">
          <span class="card-title">
            <i class="el-icon-document"></i>
            基本信息
            <span class="card-tip">请填写完整的客户资料，带 * 的为必填项</span>
          </span>
          <!-- <el-tag size="small" type="info">必填</el-tag> -->
        </div>

        <el-row :gutter="30">
          <el-col :xs="24" :sm="12">
            <el-form-item label="客户名称" prop="customerName">
              <el-input
                v-model="propsParams.customerName"
                maxlength="50"
                placeholder="请输入客户名称"
                prefix-icon="el-icon-office-building"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="业务员" prop="salesman">
              <el-input
                v-model="propsParams.salesman"
                maxlength="50"
                placeholder="请输入业务员姓名"
                prefix-icon="el-icon-user"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="30">
          <el-col :xs="24" :sm="12">
            <el-form-item label="联系人" prop="linkman">
              <el-input
                v-model="propsParams.linkman"
                maxlength="50"
                placeholder="请输入联系人姓名"
                prefix-icon="el-icon-user-solid"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="联系人电话" prop="linkmanPhone">
              <el-input
                v-model="propsParams.linkmanPhone"
                maxlength="15"
                placeholder="请输入联系人电话"
                prefix-icon="el-icon-phone"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="30">
          <el-col :xs="24" :sm="24">
            <el-form-item label="公司地址" prop="companyAddress">
              <el-input
                v-model="propsParams.companyAddress"
                maxlength="50"
                placeholder="请输入公司详细地址"
                prefix-icon="el-icon-location"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="30">
          <el-col :xs="24" :sm="12">
            <el-form-item label="使用设备" prop="useDevice">
              <el-input
                v-model="propsParams.useDevice"
                maxlength="255"
                placeholder="请输入使用设备"
                prefix-icon="el-icon-monitor"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="使用场景" prop="useScreen">
              <el-input
                v-model="propsParams.useScreen"
                maxlength="255"
                placeholder="请输入使用场景"
                prefix-icon="el-icon-suitcase"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="30">
          <el-col :xs="24" :sm="24">
            <el-form-item label="备注">
              <el-input
                v-model="propsParams.remark"
                maxlength="255"
                placeholder="如有其他补充信息，请在此填写"
                type="textarea"
                :rows="3"
                show-word-limit
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 图片资料卡片 -->
      <el-card class="form-card upload-card" shadow="hover">
        <div slot="header" class="card-header">
          <span class="card-title">
            <i class="el-icon-picture"></i>
            图片资料
          </span>
          <el-tag size="small" type="warning">必填</el-tag>
        </div>

        <div class="upload-grid">
          <!-- 使用设备的图片 -->
          <div class="upload-block">
            <div class="upload-block-label">
              使用设备的图片
            </div>
            <el-form-item prop="useDevicePicture" class="upload-only-item">
              <el-upload
                class="avatar-uploader"
                :action="url"
                accept=".jpg,.png"
                :show-file-list="false"
                :on-success="handleIdCardHeadImgSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <div v-if="propsParams.useDevicePicture" class="upload-preview">
                  <img :src="propsParams.useDevicePicture" class="avatar" />
                  <div class="upload-overlay">
                    <i class="el-icon-refresh"></i>
                    <span>重新上传</span>
                  </div>
                </div>
                <div v-else class="upload-placeholder">
                  <div class="upload-icon-wrap">
                    <i class="el-icon-camera-solid"></i>
                  </div>
                  <span class="upload-text">点击上传设备图片</span>
                  <span class="upload-hint">支持 JPG、PNG，不超过 2MB</span>
                </div>
              </el-upload>
            </el-form-item>
          </div>

          <!-- 营业执照 -->
          <div class="upload-block">
            <div class="upload-block-label">
              营业执照
            </div>
            <el-form-item prop="businessLicensePicture" class="upload-only-item">
              <el-upload
                class="avatar-uploader"
                :action="url"
                accept=".jpg,.png"
                :show-file-list="false"
                :on-success="handleIdCardBackImgSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <div v-if="propsParams.businessLicensePicture" class="upload-preview">
                  <img :src="propsParams.businessLicensePicture" class="avatar" />
                  <div class="upload-overlay">
                    <i class="el-icon-refresh"></i>
                    <span>重新上传</span>
                  </div>
                </div>
                <div v-else class="upload-placeholder">
                  <div class="upload-icon-wrap">
                    <i class="el-icon-s-order"></i>
                  </div>
                  <span class="upload-text">点击上传营业执照</span>
                  <span class="upload-hint">支持 JPG、PNG，不超过 2MB</span>
                </div>
              </el-upload>
            </el-form-item>
          </div>
        </div>
      </el-card>

      <!-- 底部操作栏 -->
      <div class="footer-bar">
        <el-button size="medium" @click="resetForm">重 置</el-button>
        <el-button size="medium" type="info" @click="saveForm">保 存</el-button>
        <el-button size="medium" type="primary" @click="submitAndFlow">提 交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { getCustomerInfo, updateCustomerInfo, submitFlowCustomer } from "@/api/api.js";
export default {
  name: "customerInformationUpdate",
  data() {
    var checkUseDevicePicture = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("使用设备的图片不能为空"));
      } else {
        callback();
      }
    };
    var checkBusinessLicensePicture = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("营业执照不能为空"));
      } else {
        callback();
      }
    };
    return {
      url: "cms/file/upload/customerInformation",
      id: this.$route.query && this.$route.query.id,
      propsParams: {
        id: undefined,
        useDevicePicture: undefined,
        businessLicensePicture: undefined,
        customerName: undefined,
        companyAddress: undefined,
        salesman: undefined,
        useDevice: undefined,
        useScreen: undefined,
        linkman: undefined,
        linkmanPhone: undefined,
        remark: undefined,
      },
      rules: {
        customerName: [
          { required: true, message: "客户名称不能为空", trigger: "blur" },
        ],
        companyAddress: [
          { required: true, message: "公司地址不能为空", trigger: "blur" },
        ],
        salesman: [
          { required: true, message: "业务员不能为空", trigger: "blur" },
        ],
        useDevice: [
          { required: true, message: "使用设备不能为空", trigger: "blur" },
        ],
        useScreen: [
          { required: true, message: "使用场景不能为空", trigger: "blur" },
        ],
        linkmanPhone: [
          {
            required: true,
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        linkman: [
          { required: true, message: "联系人不能为空", trigger: "blur" },
        ],
        useDevicePicture: [
          { required: true, validator: checkUseDevicePicture, trigger: "blur" },
        ],
        businessLicensePicture: [
          {
            required: true,
            validator: checkBusinessLicensePicture,
            trigger: "blur",
          },
        ],
      },
      showCountDown: true,
      count: "",
      timer: null,
    };
  },
  computed: {
    adminShow() {
      return (
        this.$store.getters.user.roleType == "0" ||
        this.$store.getters.user.roleType == "1"
      );
    },
  },
  methods: {
    resetForm() {
      this.$nextTick(() => {
          if (this.$refs['ruleForm']) {
              this.$refs['ruleForm'].resetFields();
          }
      });
    },
    getCustomerDetail() {
      let id = this.$route.query && this.$route.query.id;
      getCustomerInfo({ id: id }).then((res) => {
        this.propsParams = res.data.data;
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    handleIdCardHeadImgSuccess(res, file) {
      if (res.code == 200) {
        this.propsParams.useDevicePicture = "/cms/" + res.data.url;
      }
    },
    handleIdCardBackImgSuccess(res, file) {
      if (res.code == 200) {
        this.propsParams.businessLicensePicture = "/cms/" + res.data.url;
      }
    },
    saveForm() {
      if (!this.propsParams.customerName) {
        this.$message.error("客户名称不能为空");
        return;
      }
      let params = {
        ...this.propsParams,
      };
      updateCustomerInfo(params).then((res) => {
        if (res.data.code == 200) {
          this.$notify({
            title: "成功",
            message: "���改成功",
            type: "success",
            duration: 1500,
          });
          this.$store.dispatch("tagsView/delView", this.$route);
          this.$router.push("/shipment/customerInformation");
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    isValidMobileNumber(phoneNumber) {
      const regex = /^1[3-9]\d{9}$/;
      return regex.test(phoneNumber);
    },
    isValidLineNumber(landlineNumber) {
      const regex = /^(\d{3,4})-?(\d{7,9})$/;
      return regex.test(landlineNumber);
    },
    submitAndFlow() {
      let params = {
        ...this.propsParams,
      };
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          submitFlowCustomer(params).then((res) => {
            if (res.data.code == 200) {
              this.$notify({
                title: "成功",
                message: "提交成功",
                type: "success",
                duration: 1500,
              });
              this.$store.dispatch("tagsView/delView", this.$route);
              this.$router.push("/shipment/customerInformation");
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
  },
  mounted() {},
  watch: {
    "$route": {
      handler(to, from) {
        if (to.name !== "customerInformationUpdate") return;
        const newId = to.query && to.query.id;
        if (newId === this.id) return;
        this.id = newId;
        this.resetForm();
        this.getCustomerDetail();
      },
      deep: true,
    },
  },
  created() {
    this.getCustomerDetail();
  },
};
</script>

<style scoped lang="less">
@primary: #409eff;
@primary-light: #ecf5ff;
@border-radius: 10px;
@card-bg: #ffffff;
@text-main: #303133;
@text-sub: #606266;
@text-light: #909399;

.customer-add-page {
  min-height: 100%;
  background: #f5f7fa;
  padding: 24px;
  padding-bottom: 100px;
  box-sizing: border-box;
}

/* 页面头部 */
.page-header {
  margin-bottom: 24px;
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;

  .header-left {
    display: flex;
    align-items: center;
    gap: 16px;

    .header-icon {
      width: 48px;
      height: 48px;
      border-radius: 12px;
      background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
      color: #fff;
      font-size: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .page-title {
      font-size: 22px;
      font-weight: 700;
      color: @text-main;
      margin: 0 0 4px 0;
    }

    .page-subtitle {
      font-size: 13px;
      color: @text-light;
      margin: 0;

      .required-star {
        color: #f56c6c;
        font-weight: 700;
      }
    }
  }
}

/* 表单卡片 */
.customer-form {
  max-width: 1100px;
  margin: 0 auto;

  .form-card {
    border-radius: @border-radius;
    border: none;
    margin-bottom: 20px;
    background: @card-bg;
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
    }

    /deep/ .el-card__header {
      padding: 14px 20px;
      border-bottom: 1px solid #f0f2f5;
      background: #ffffff;
      border-radius: @border-radius @border-radius 0 0;
    }

    /deep/ .el-card__body {
      padding: 20px 20px;
    }

    .el-row:not(:last-child) {
      margin-bottom: 16px;
    }

    .card-header {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .card-title {
        font-size: 16px;
        font-weight: 600;
        color: @text-main;
        display: flex;
        align-items: center;
        gap: 8px;

        i {
          color: @primary;
          font-size: 18px;
        }

        .card-tip {
          font-size: 12px;
          font-weight: 400;
          color: @text-light;
          margin-left: 4px;
        }
      }
    }

    /* 表单项样式 */
    /deep/ .el-form-item {
      margin-bottom: 24px;

      &:last-child {
        margin-bottom: 0;
      }

      .el-form-item__label {
        font-weight: 500;
        color: @text-sub;
        padding-right: 16px;
      }

      .el-input__inner {
        border-radius: 8px;
        height: 40px;
        transition: all 0.2s ease;

        &:hover {
          border-color: @primary;
        }

        &:focus {
          border-color: @primary;
          box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
        }
      }

      .el-textarea__inner {
        border-radius: 8px;
        transition: all 0.2s ease;

        &:hover {
          border-color: @primary;
        }

        &:focus {
          border-color: @primary;
          box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
        }
      }
    }
  }
}

/* 上传区域 */
.upload-card {
  /deep/ .el-card__body {
    padding: 32px 24px;
  }

  .upload-grid {
    display: flex;
    justify-content: center;
    gap: 80px;
    flex-wrap: wrap;
  }

  .upload-block {
    display: flex;
    flex-direction: column;
    align-items: center;

    .upload-block-label {
      font-size: 14px;
      font-weight: 500;
      color: @text-sub;
      margin-bottom: 10px;
      text-align: center;
    }

    .upload-only-item {
      margin-bottom: 0 !important;

      /deep/ .el-form-item__content {
        margin-left: 0 !important;
        display: flex;
        justify-content: center;
      }
    }
  }
}

.avatar-uploader {
  width: 220px;
  height: 220px;
  border-radius: 14px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;

  .upload-placeholder {
    width: 100%;
    height: 100%;
    border: 2px dashed #dcdfe6;
    border-radius: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    background: #fafbfc;
    padding: 16px;
    text-align: center;
    transition: all 0.3s ease;

    .upload-icon-wrap {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      background: @primary-light;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 2px;
      transition: all 0.3s ease;

      i {
        font-size: 28px;
        color: @primary;
      }
    }

    .upload-text {
      font-size: 14px;
      color: @text-sub;
      font-weight: 500;
    }

    .upload-hint {
      font-size: 12px;
      color: @text-light;
    }
  }

  &:hover {
    .upload-placeholder {
      border-color: @primary;
      background: @primary-light;

      .upload-icon-wrap {
        background: @primary;

        i {
          color: #fff;
        }
      }

      .upload-text {
        color: @primary;
      }
    }
  }

  .upload-preview {
    width: 220px;
    height: 220px;
    border-radius: 14px;
    position: relative;
    overflow: hidden;
    border: 1px solid #ebeef5;

    .avatar {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }

    .upload-overlay {
      position: absolute;
      inset: 0;
      background: rgba(0, 0, 0, 0.55);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 6px;
      opacity: 0;
      transition: opacity 0.3s ease;
      color: #fff;

      i {
        font-size: 28px;
      }

      span {
        font-size: 13px;
      }
    }

    &:hover .upload-overlay {
      opacity: 1;
    }
  }
}

/* 底部操作栏 */
.footer-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: @card-bg;
  padding: 12px 24px;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  z-index: 100;
  border-top: 1px solid #f0f2f5;

  .el-button {
    min-width: 120px;
    height: 40px;
    border-radius: 8px;
    font-weight: 500;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: all 0.2s ease;

    i {
      font-size: 16px;
    }
  }

  .btn-cancel {
    border-color: #dcdfe6;
    color: @text-sub;

    &:hover {
      border-color: @primary;
      color: @primary;
      background: @primary-light;
    }
  }

  .btn-save {
    &:hover {
      background: @primary-light;
    }
  }

  .btn-submit {
    background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
    border: none;

    &:hover {
      background: linear-gradient(135deg, #66b1ff 0%, #409eff 100%);
      box-shadow: 0 4px 12px rgba(64, 158, 255, 0.35);
      transform: translateY(-1px);
    }
  }
}

/* 响应式 */
@media (max-width: 768px) {
  .customer-add-page {
    padding: 16px;
  }

  .form-card {
    /deep/ .el-card__body {
      padding: 20px 16px !important;
    }
  }

  .footer-bar {
    flex-direction: column;
    gap: 10px;
    padding: 12px 16px;

    .el-button {
      width: 100%;
      max-width: 400px;
    }
  }

  .avatar-uploader {
    width: 180px;
    height: 180px;

    .upload-preview {
      width: 180px;
      height: 180px;
    }
  }

  .upload-grid {
    gap: 40px !important;
  }
}
</style>
